import {texture} from "p3";
import definitions from "../../../definitions";
import NPC from "./NPC";

export default class NPCBarbarian extends NPC {
    constructor() {
        super(definitions.NPC_ID.BARBARIAN);

        this.collisionRadius = 80;
        this.collisionOffsetX = -12;
        this.collisionOffsetY = -38;
    }

    init() {
        super.init();

        this.addViewWithTexture(texture("char_barbarian_idle_00"));

        this.addShadow(definitions.SHADOW_SIZE.LARGE, 1, new PIXI.Point(-14, -14));
        this.animateIdle(1);
    }
}